import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '@splidejs/react-splide/css';
import '@/styles/globals.css';
import { Analytics } from '@vercel/analytics/react';
import ClientRootLayout from '../components/ClientRootLayout';
import { Component } from 'react';
import Head from 'next/head';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h2>ERROR!</h2>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function App({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <meta name="apple-mobile-web-app-title" content="SaunaAtlas" />
      </Head>
      <ErrorBoundary>
        <ClientRootLayout>
          <Component {...pageProps} />
          <Analytics />
        </ClientRootLayout>
      </ErrorBoundary>
    </>
  );
}